// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetParentElementsRequestModel from '../../model/get-parent-elements-request-model';
import GetParentElementsRequestDTO from '../dto/get-parent-elements-request-dto';
import dtoSchema from '../schemas/get-parent-elements-request-schema';

export default abstract class GetParentElementsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetParentElementsRequestDTO>) {
    super();
    if (data) {
      this.projectId = data.projectId;
    }
  }
  /**
  * @type {uuid}
  */
  projectId?: string;

  static toModel(dto: DeepPartial<GetParentElementsRequestDTO>): GetParentElementsRequestModel;
  static toModel(dto: DeepPartial<GetParentElementsRequestDTO> | undefined | null): GetParentElementsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetParentElementsRequestDTO> | undefined | null): GetParentElementsRequestModel | undefined {
    return dto ? new GetParentElementsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetParentElementsRequestModel> | GetParentElementsRequestModel): GetParentElementsRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      projectId: unwrapped.projectId,
    } as GetParentElementsRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetParentElementsRequestModel, can not map to GetParentElementsRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
